import { alpha } from '@mui/material/styles'
import { ReactComponent as Square } from '../../../assets/icons/square.svg'
import theme from '../base'

const table = {
  MuiTableSortLabel: {
    defaultProps: {
      icon: <Square />,
    },
    styleOverrides: {
      root: {
        '&.Mui-active': {
          color: theme.palette.neutral.main,
        },
        '&:hover .MuiSvgIcon-root': {
          color: theme.palette.primary.main,
          opacity: 1,
        },
      },
      icon: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        opacity: 1,
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        boxShadow: theme.shadows[1],
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&.MuiTableRow-hover': {
          '&:hover': {
            backgroundColor: theme.palette.neutral.white,
            boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
            position: 'relative',
            zIndex: 1,
          },
        },
        '&.is-selected': {
          backgroundColor: theme.palette.neutral.lightest,
          '&:hover': {
            backgroundColor: theme.palette.neutral.lightest,
          },
        },
        '&.primary': {
          backgroundColor: alpha(theme.palette.error.light, 0.2),
          '&.MuiTableRow-hover': {
            '&:hover': {
              backgroundColor: alpha(theme.palette.error.light, 0.2),
            },
          },
        },
        '&.yellow': {
          backgroundColor: alpha(theme.palette.yellow.lighter, 0.2),
          '&.MuiTableRow-hover': {
            '&:hover': {
              backgroundColor: alpha(theme.palette.yellow.lighter, 0.2),
            },
          },
        },
      },
      hover: {
        transition: theme.transitions.create(['box-shadow'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.short,
        }),
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        maxWidth: theme.spacing(28),
        height: theme.spacing(5),
        padding: theme.spacing(0.5, 1),
        borderBottomColor: theme.palette.neutral.lightest,
        ...theme.typography.body2,
        '&.truncate': {
          '& span': {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '20ch',
          },
        },
        '&.truncateXS': {
          '& span': {
            width: '11ch',
          },
        },
        '&.subtableWrapper': {
          height: 0,
          padding: 0,
          borderBottom: 'none',
        },
        '& .MuiChip-root': {
          margin: 0,
        },
        '& .MuiIconButton-root': {
          '&.is-expanded': {
            color: theme.palette.primary.main,
            transform: 'rotate(180deg)',
          },
        },
      },
      head: {
        color: theme.palette.neutral.main,
        fontWeight: 700,
        '&.small': {
          minWidth: theme.spacing(11),
          paddingRight: 0,
        },
        '&.big': {
          minWidth: theme.spacing(20),
        },
      },
      paddingCheckbox: {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        '& .MuiCheckbox-root': {
          margin: 0,
          padding: theme.spacing(0, 1),
        },
      },
      body: {
        color: theme.palette.neutral.main,
        '&.main': {
          fontWeight: 700,
        },
        '&.icon': {
          width: theme.spacing(4.5),
          padding: theme.spacing(0.5),
        },
      },
    },
  },
}

export default table
